module.exports = __webpack_public_path__ + "static/media/steve-greg.8a986ac2.jpg";